export function normalizePayload(payload) {
    let normalizedPayload = Object.assign({}, payload);
    if(payload.username) {
        normalizedPayload.username = payload.username.trim().toLowerCase();
    }
    if(payload.password) {
        normalizedPayload.password = payload.password.trim();
    }
    return normalizedPayload
}